import actionCreatorFactory from 'typescript-fsa';
import { Story } from './stories.reducer';
import { InitialStory } from '../../../modules/StoryCreate/index';
const actionCreator = actionCreatorFactory('Stories');

export const updateStories = actionCreator<{
  [key: number]: Story;
}>('STORIES_UPDATE');
export const createStory = actionCreator<InitialStory>('STORIES_CREATE');
export const getStory = actionCreator<{ storyId: Number }>('STORY_GET');
export const singleStoryFetched = actionCreator<Story>('STORY_SINGLE_FETCHED');
export const redirectToCreateStory = actionCreator(
  'STORIES_REDIRECT_TO_CREATE'
);



// WEBPACK FOOTER //
// ./src/store/Entities/Stories/stories.actions.ts